import { useState, useEffect } from 'react';
import { ProjectsModel } from '../models/projectsModel';
import { useLanguage } from '../i18n/LanguageContext';

export function useProjectsController() {
  const { selectedLanguage } = useLanguage();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);

    ProjectsModel.fetch(selectedLanguage)
      .then(d => {
        if (active) setData(d);
      })
      .catch(e => {
        if (active) setError(e);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [selectedLanguage]);

  return { data, loading, error };
}

export function useProjectControllerById(projectId) {
  const { selectedLanguage } = useLanguage();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);

    ProjectsModel.fetchById(projectId, selectedLanguage)
      .then(d => {
        if (active) setData(d);
      })
      .catch(e => {
        if (active) setError(e);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [projectId, selectedLanguage]);

  return { data, loading, error };
}
